import {IWixAPI} from '@wix/native-components-infra/dist/src/types/types'
import {draftEventPreviewUrlQueryParamName} from '@wix/wix-events-commons-statics'

export const getDraftToken = (wixCodeApi: IWixAPI) => {
  const {query} = wixCodeApi.location
  return query[draftEventPreviewUrlQueryParamName]
}
